import * as MediaPreviewType from '../../constants/MediaPreviewType.js';
import MediaPreviewEmbed from '../MediaPreviewEmbed/MediaPreviewEmbed.js';

function MediaPreviewYoutubeShort2({
  linkUrl,
  getHeightOfIframe,
}: {
  linkUrl: string;
  getHeightOfIframe?: (previewType: number) => number;
}) {
  if (!linkUrl) {
    return <div>Youtube Short URL could not be parsed</div>;
  }
  const heightOfIframe = getHeightOfIframe?.(MediaPreviewType.EmbedYoutubeShort) || 136;
  return (
    <MediaPreviewEmbed
      url={linkUrl}
      getHeightOfIframe={() => heightOfIframe}
      testId="MediaPreviewYoutubeShort"
    />
  );
}

export default MediaPreviewYoutubeShort2;
